import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../hoc/Loading/Loading";
import axios from "../../axios";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../utils/url";
import {
  Card,
  Button,
  CardTitle,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  CardText,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";
import sortBy from "lodash/sortBy";
import {
  kpiBasedType,
  dtickFormat,
  findNodeinHierarchy,
  selectOfficeCheck,
  chartLineColor,
  get_max_plot_ticks,
  plotlyMarkerTypes,
  benchmarkLineTypes,
  legendPosition,
  KPISbyMonth,
  chartMarkerSymbolsVariation,
  chartMarkerSymbols,
  constructGroupLinkedUsersText,
  checkNoDataLayoutValidity,
  getEmptyGraphLayoutObject,
  getAvgTenureFormatted,
} from "../../utils/constants";
import moment from "moment";
import { chartKpiDataFieldRefTransformationSingleChart, generateLegendTitle } from "../../utils/chartUtils";
import find from "lodash/find";
import Plot from "../../utils/customPlotly";
import ManualEntryModal from "../../pages/analytics/ChartList/ManualEntryModal";
import ViewChart from "../../pages/analytics/ViewChart/ViewChart";
import ChartAverageTable from "../analytics/ViewChart/ChartAverageTable";
import If from "../../components/Shared/If";
import { deepClone } from "../../utils/copyObject";

class LinkedChartItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chart: null,
      isRemoved: false,
      clickedPoint: null,
      dropdownOpen: false,
      showManualEntryAnswersModal: false,
      showViewChart: false,
      annotations:[]
    };
  }

  componentDidMount() {
    let { chart } = this.props;
    if (chart && chart.name) {
      let res = this.processKpiData(chart);
      this.setState({
        chart: { ...res },
      });
    }
  }



  // componentDidUpdate(prevProps) {
  //   console.log(this.props.chart, '------', prevProps.chart)
  //   // if (this.props.chart !== prevProps.chart) {
  //   //   let{chart}=this.props
  //   //   let res = this.processKpiData(chart);
  //   //   console.log('update--', res.name)
  //   //   this.setState({
  //   //     chart:{...res}
  //   //   })
  //   // }
  // }

  chartLineMarkerGenerator = (color, type,length) => {
    // let value = Math.floor(Math.random()*16777215).toString(16)
    // let color = `#${value}`.toUpperCase();
    let obj;

    if (type === "line") {
      obj = {
        color,
        width: 1,
      };
    } else {
      let marker = Math.floor(Math.random() * 9);
      let variation = Math.floor(Math.random() * 3);
      let symbol = `${chartMarkerSymbols[marker]}${chartMarkerSymbolsVariation[variation]}`;
      obj = {
        color: [...Array(length).fill(color)],
        size: 10,
        symbol,
      };
    }
    return obj;
  };

  kpiGoalValue = (chart, kpi, index) => {
    if (chart && chart.goals && chart.goals.length > 0) {
      if (kpi && kpi.kpiId && kpi.kpiId._id) {
        let result = chart.goals.filter(
          e =>
            e.kpiId === kpi.kpiId._id &&
            parseInt(e.name.match(/\d+/)[0]) === index + 1
        );
        if (result && result.length > 0) {
          return result[0];
        }
      }
    }
    return {};
  };

  processKpiData = chart => {
    const { profile } = this.props.user;

    chart = chartKpiDataFieldRefTransformationSingleChart(chart)

    let max = 1,
      yRange,
      min = 0,
      y,
      yPercent,
      xMinDate,
      layout,
      xMaxDate,
      dtickFormatVal,
      yAxisFormat = chart.yAxisFormat,
      templateType,
      yAlt;

    const kpi = chart.kpiData.map((kpi, index) => {
      let goalValue = this.kpiGoalValue(chart, kpi, index);

      const sortedKpiAggregate = sortBy(kpi.score, (kpi, i) => kpi.date);
      let avgTenure = false
      let text = sortedKpiAggregate.map(val => {
        let value_floor = Math.round(val.value);
        if(val && val.avgTenure){
          avgTenure = true;
        }
        let textString = [];
        let ts;
        let ethnicity = val.numeratorEthnicity ? val.numeratorEthnicity : "";
        let kpiCode = kpi.kpiId.code;

        if (KPISbyMonth.indexOf(kpiCode) > -1) {
          let t = moment.utc(val.date).format("MMMM YYYY");
          textString.push(t);
        } else {
          let t = moment.utc(val.date).format("MMMM D, YYYY");
          textString.push(t);
        }

        if (
          !val.numeratorCount ||
          val.numeratorCount === undefined ||
          typeof val.numeratorCount == "undefined"
        ) {
          val.numeratorCount = 0;
        }
        if (val && val.numeratorType && val.totalEmployees) {
          if (kpi.kpiId.code === "COMP-1" || kpi.kpiId.code === "COMP-2") {
            ts = ethnicity
              ? `${ethnicity} ${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }, male count: ${
                  val.totalEmployees
                    ? val.totalEmployees - val.numeratorCount
                    : null
                }`
              : `${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }, male count: ${
                  val.totalEmployees
                    ? val.totalEmployees - val.numeratorCount
                    : null
                }`;
            textString.push(ts);
          } else {
            ts = ethnicity
              ? `${ethnicity} ${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }, total: ${val.totalEmployees ? val.totalEmployees : null}`
              : `${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }, total: ${val.totalEmployees ? val.totalEmployees : null}`;
            textString.push(ts);
          }
        } else if (val && val.numeratorType && !val.totalEmployees) {
          ts = ethnicity
            ? `${ethnicity} ${val.numeratorType
                .substring(1)
                .replace(/-/g, ", ")
                .toLowerCase()} count: ${val.numeratorCount}${
                yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
              }`
            : `${val.numeratorType
                .substring(1)
                .replace(/-/g, ", ")
                .toLowerCase()} count: ${val.numeratorCount}${
                yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
              }`;
          textString.push(ts);
        } else if (val.totalEmployees && !val.numeratorType) {
          ts = `of total: ${val.totalEmployees ? val.totalEmployees : null}`;
          textString.push(ts);
        } else {
          textString.push("");
        }

        let goalText = "";
        if (goalValue && goalValue.number) {
          let diff = parseInt(goalValue.number) - Math.round(val.value);
          let res = Math.round(diff);
          if (res > 0) {
            goalText = `Until Goal met: ${res}%`;
            textString.push(goalText);
          } else {
            goalText = `Goal reached 😀👍!`;
            textString.push(goalText);
          }
        } else {
          goalText = "";
          textString.push(goalText);
        }

        if(val.avgTenure >= 0 && val.avgTenure != null){
          const tenureString = `Avg Tenure: ${getAvgTenureFormatted(val.avgTenure)}`
          console.log({textString})
          if(textString[2]==""){
            textString[2] = tenureString
            textString[3] = ""
          }
          else{
            textString.push(tenureString)
          }
        }else{
          textString.push("")
        }
        return textString;
      });

      if (yAxisFormat === "Absolute") {
        y = sortedKpiAggregate.map(kpi => kpi.numeratorCount);
        yAlt = sortedKpiAggregate.map(kpi => Math.round(kpi.value) / 100);
      } else {
        y = sortedKpiAggregate.map(kpi => Math.round(kpi.value) / 100);
        yAlt = sortedKpiAggregate.map(kpi => kpi.numeratorCount);
      }

      let description = generateLegendTitle(
        kpi,
        kpi.kpiId.description,
        index,
        false,
        "",
        ""
      );
      let kpiCount = index + 1;

      sortedKpiAggregate.map(kpi => {
        let yVal;
        if (yAxisFormat === "Absolute") {
          yVal =
            kpi.data.totalEmployees !== undefined
              ? kpi.data.totalEmployees
              : kpi.totalEmployees;
        } else {
          yVal = kpi.value / 100;
        }
        if (yVal > max) {
          max = yVal;
        }
      });

      if (yAxisFormat == "Absolute") {
        yRange = [min - 1, max + 100];
        yAxisFormat = "Absolute";
        templateType =
          "<b>%{text[0]}</b>, " +
          `<b>%{y:.0}</b> (KPI ${kpiCount}) <br>` +
          "%{text[1]}<br>" +
          "%{text[2]}<br>" +
          "%{text[3]}<br>" +
          "<extra></extra>";
      } else {
        yRange = [min - 0.15, max + 0.1];
        yAxisFormat = "";
        templateType =
          "<b>%{text[0]}</b>, " +
          `<b>%{y:.0%}</b> (KPI ${kpiCount}) <br>` +
          "%{text[1]}<br>" +
          "%{text[2]}<br>" +
          "%{text[3]}<br>" +
          "<extra></extra>";
      }
      let chartColor = chartLineColor(index);

      let x = sortedKpiAggregate.map(kpi => {
        let date1 = moment.utc(kpi.date).format("YYYY-MM-DD");
        if (xMinDate == undefined || xMinDate > date1) {
          xMinDate = date1;
        }

        if (xMaxDate == undefined || date1 > xMaxDate) {
          xMaxDate = date1;
        }
        return kpi.date;
      });
      let length = x.length;
      dtickFormatVal = dtickFormat(xMinDate, xMaxDate, length, 0.33);
      return {
        name: `${description}`,
        description,
        y,
        x,
        yAlt,
        text,
        hovertemplate: templateType,
        type: "scatter",
        line: this.chartLineMarkerGenerator(chartColor, "line"),
        marker: this.chartLineMarkerGenerator(chartColor, "marker",x.length),
        xaxis: "x",
        yaxis: "y",
        id: kpi.kpiId._id,
        lines: "scatter",
        mode: length > 12 ? "lines" : "lines+markers",
      };
    });

    let benchmark = {};
    if (chart.benchmarkData) {
      let { industriesList } = this.state;
      let industry = find(industriesList, {
        _id: profile.organizationId.industry,
      });
      let { score } = chart.benchmarkData;
      let sortedDataArray = sortBy(score, data => data.date);
      const singleBenchmark = sortedDataArray.length === 1;
      benchmark.name = `Benchmark`;

      if (chart.kpiData.length === 0) {
        benchmark.description = generateLegendTitle(
          null,
          chart.category,
          0,
          true,
          industry ? industry.name : "",
          chart.benchmarkData.location
        );
      } else {
        benchmark.description = generateLegendTitle(
          chart.kpiData[0],
          chart.kpiData[0].kpiId.description,
          0,
          true,
          industry ? industry.name : ""
        );
      }

      benchmark.x = sortedDataArray.map(benchmark => benchmark.date);
      benchmark.y = sortedDataArray.map(benchmark => benchmark.value / 100);
      benchmark.type = "scatter";
      benchmark.line = benchmarkLineTypes[0];
      benchmark.marker = singleBenchmark
        ? plotlyMarkerTypes[3]
        : plotlyMarkerTypes[0];
      benchmark.xaxis = "x";
      benchmark.yaxis = "y";
    }

    const showEmptyLayout = checkNoDataLayoutValidity(kpi);
    if (showEmptyLayout) {
      layout = getEmptyGraphLayoutObject({
        l:25,r:10,t:10,b:25
      },18);
    }
    chart.layout = layout;
    chart.benchmark = benchmark;
    chart.kpiForPlotly = kpi;
    chart.yAxisFormat = yAxisFormat;
    chart.yRange = yRange;
    chart.xMinDate = xMinDate;
    chart.xMaxDate = xMaxDate;
    chart.dtickFormat = dtickFormatVal;
    return chart;
    // chart.kpiDescription = description
  };

  

  onPlotlyUpdate = plot => {
    let { rangeInit } = this.state;
    if (plot && plot.layout && plot.layout.xaxis) {
      let { range } = plot.layout.xaxis;
      if (
        rangeInit &&
        rangeInit != null &&
        rangeInit.length > 1 &&
        range.length > 1
      ) {
        let plotlyDTick = dtickFormat(range[0], range[1]);
        let pTick2 = dtickFormat(rangeInit[0], rangeInit[1]);
        // console.log(pTick2, '----', plotlyDTick)
        if (pTick2 != plotlyDTick) {
          this.setState({ rangeInit: range, plotlyDTick });
        }
      } else {
        this.setState({ rangeInit: range });
      }
    }
  };

  handleChartPointClick = (a) => {
    let { chart } = this.state;
    if (chart && chart.name && chart.kpiType) {
      let { kpiType } = chart;
      if (kpiType === kpiBasedType.surveyBased) {
        this.setState({
          showManualEntryAnswersModal: true,
          clickedPoint: a,
        });
      }
    }

    const annotations_old = [...this.state.annotations];

    const getAvgTenureIfAvailable=(pointData,pointIndex)=>{
      if(pointData && pointIndex>=0){
        if(pointData.data && pointData.data.text && pointData.data.text.length){
          for (const str of pointData.data.text[pointIndex]) {
            if(str.indexOf("Avg Tenure")>=0){
              return ", "+str;
            }
          }
        }
      }
      return "";
    }

    if (a.points && a.points[0] && a.points[0].data) {
      const pointIndex = a.points[0].pointIndex;
      const curveIndex = a.points[0].curveNumber;
      const pointData = a.points[0];
      let annotate_text = `${pointData.text[0]}, ${Math.round(pointData.y *
        100)}% ${getAvgTenureIfAvailable(pointData,pointIndex)}`;

      let annotation = {
        text: annotate_text,
        x: pointData.x,
        y: parseFloat(pointData.y.toPrecision(2)),
        borderwidth:1,
        clicktoshow:"onoff"
      };

      annotations_old.push(annotation);

      this.setState({ annotations: annotations_old });

     
        this.updateChartPointers(
  
          pointIndex,
          curveIndex
        );
      
    }
  };

  handleChartPointDoubleClick = (a) => {
    this.setState({ annotations: [] });
      this.resetChartPointers();
    
  };

  updateChartPointers = (pointIndex, curveIndex) => {
    let currentChartObject = { ...this.state.chart };

    const kpiForPlotlyArray = currentChartObject.kpiForPlotly
      ? [...currentChartObject.kpiForPlotly]
      : [];

    let kpiForPlotlyObject = kpiForPlotlyArray[curveIndex];

    if (kpiForPlotlyObject) {
      const marker = kpiForPlotlyObject.marker;

      // marker.color = "rgb(255,0,0)"

      if (marker) {
        const new_color = marker.color;

        new_color[pointIndex] = "rgb(255,0,0)";

        marker.color = deepClone(new_color);

        kpiForPlotlyObject = {
          ...kpiForPlotlyObject,
          marker,
        };

        kpiForPlotlyArray[curveIndex] = kpiForPlotlyObject;

        currentChartObject = {
          ...currentChartObject,
          kpiForPlotly: [...kpiForPlotlyArray],
        };

        this.setState({ chart: currentChartObject });
      }
    }
  };

  resetChartPointers = () => {
    const { chart } = this.state;

    const newCharts = {
      ...chart,
      kpiForPlotly: chart.kpiForPlotly.map((kpi, idx) => ({
        ...kpi,
        marker: {
          ...kpi.marker,
          color:
            kpi.x && kpi.x.length && kpi.line
              ? [...Array(kpi.x.length).fill(kpi.line.color)]
              : chartLineColor(idx),
        },
      })),
    };

    this.setState({ chart: newCharts });
  };

  renderPlot = () => {
    let { profile } = this.props.user,
      { staticHierarchy } = profile.organizationId;
    let { chart } = this.state,
      { name, yAxisFormat, dtickFormat, benchmarkArray, kpiForPlotly, yRange } =
        chart;
    let yTickFormat,
      plotlyData = [];

    if (yAxisFormat === "Absolute") {
      yTickFormat = ".3%";
    } else {
      yTickFormat = "";
    }

    plotlyData.concat(benchmarkArray);
    if (kpiForPlotly) {
      plotlyData = plotlyData.concat(kpiForPlotly);
    }

    let plotlyKpiData = plotlyData.filter(
      data =>
        data.name !== "Benchmark for KPI" &&
        data.x.length > 0 &&
        data.y.length > 0
    );
    let plotlyBenchMarkData = plotlyData.filter(
      data => data.name === "Benchmark for KPI"
    );
    let combinedPlotlyData = [...plotlyKpiData, ...plotlyBenchMarkData];

    let tickvalsString = null;
    if (combinedPlotlyData.length === 1) {
      if (combinedPlotlyData[0].x.length === 1) {
        tickvalsString = [combinedPlotlyData[0].x[0]];
      }
    }

    if (combinedPlotlyData.length > 1) {
      let tickvalsList = combinedPlotlyData.map(data => {
        let xvalues = data.x;
        return xvalues;
      });
      let filteredTickvalsList = tickvalsList.filter(
        tickValue => tickValue.length === 1
      );
      if (
        tickvalsString == null &&
        tickvalsList.length > 0 &&
        tickvalsList.length === filteredTickvalsList.length
      ) {
        let firstTickVal = filteredTickvalsList[0][0];
        let filterTickVal = filteredTickvalsList.filter(tickVal =>
          moment(tickVal[0]).isSame(firstTickVal, "month")
        );
        if (filterTickVal.length === filteredTickvalsList.length) {
          tickvalsString = [firstTickVal];
        }
      }
    }

    let selectorOptions = {
      buttons: [
        {
          step: "month",
          stepmode: "backward",
          count: 4,
          label: "last 3m",
        },
        {
          step: "month",
          stepmode: "backward",
          count: 7,
          label: "6m",
        },
        {
          step: "year",
          stepmode: "backward",
          count: 1,
          label: "1y",
        },
        {
          step: "all",
        },
      ],
      // activecolor
    };

    return (
      <div>
        <Plot
          data={plotlyData}
          layout={chart.layout ? {...chart.layout,   annotations: this.state.annotations,} :  {
            annotations: this.state.annotations,
            showlegend: false,
            autosize: true,
            pull: [0.8, 0, 0],
            uirevision: true,
            // legend: {
            //   bgcolor:'white',
            //   xanchor: "left",
            //   // y:yLegend,
            //   x:0
            // },
            paper_bgcolor: "white",
            plot_bgcolor: "#e5ecf694",
            margin: {
              l: 5,
              r: 5,
              b: 5,
              t: 35,
              pad:0,
            },
            xaxis: {
              showgrid: true,
              type: "date",
              ticks:'outside',
              automargin: true,
              dtick: dtickFormat,
              tickformat: typeof dtickFormat != "number" ? "%b<br>%Y" : "%b %e",
              tick0: chart.xMinDate,
              rangeselector: selectorOptions,
              tickfont: { color: "#313236" },
              nticks: get_max_plot_ticks(30),
            },
            yaxis: {
              zerolinecolor: "#ffffff",
              zerolinewidth: 1,
              gridcolor: "#ffffff",
              gridwidth: 1,
              tickformat:
                chart.yAxisFormat && chart.yAxisFormat == "Absolute"
                  ? undefined
                  : "%",
              tickfont: { color: "#313236" },
              range: yRange,
              // fixedrange:true,
              automargin: true,
              ticklabelposition:'outside left',
            },
            hovermode: "closest",
          }}
          scrollZoom={true}
          config={{
            scrollZoom: true,
            modeBarButtonsToRemove: ["pan2d", "select2d", "lasso2d"],
            displaylogo: false,
            responsive: true,
            toImageButtonOptions: {
              format: "png", // one of png, svg, jpeg, webp
              filename: `${name} - ${moment(new Date()).format("MM-D-YYYY")}`,
              height: 600,
              width: null,
              scale: 1, // Multiply title/legend/axis/canvas sizes by this factor
            },
          }}
          className="recentActivity plotlyChart"
          onUpdate={figure => this.onPlotlyUpdate(figure)}
          onClick={this.handleChartPointClick}
          onDoubleClick={this.handleChartPointDoubleClick}
        />
        <ChartAverageTable
          chartSelector={"_id" + chart._id}
          kpiForPlotly={chart.kpiForPlotly}
          yAxisFormat={chart.yAxisFormat}
          isPopup
          chart={chart}
        />
      </div>
    );
  };

  navigateToChart = value => {
    if (value == "isChartNotesDisplay") {
      this.setState({ showViewChart: true, isChartNotesDisplay: true });
    } else {
      this.setState({ showViewChart: true });
    }
  };

  removeGroup = item => {
    let { chart } = this.state;
    if (this.props.group) {
      let payload = {
        modelId: item._id,
        modelName: "Chart",
        itemType: item.category,
        groupId: this.props.group._id,
      };

      // delete chart._id

      // this.setState({chart})

      let that = this;
      axios.post(url.removeGrpItem, payload).then(({ data }) => {
        that.setState({
          isRemoved: true,
          // chart
        });
        that.props.removeChart(payload);
      });
    }
  };

  toggle = () => {
    const { dropdownOpen } = this.state;
    this.setState({ dropdownOpen: !dropdownOpen });
  };

  closeViewChartModal = () => {
    this.setState({ showViewChart: false });
  };

  renderView = () => {
    let {
      chart,
      showManualEntryAnswersModal,
      isRemoved,
      clickedPoint,
      showViewChart,
    } = this.state;

    if (chart && chart._id) {
      let { kpiData, attachedDate, attachedBy } = chart;
      let { firstName, lastName } = chart.createdBy;
      return (
        <div
          className={`card linkedCharts linkedChartItemStyling ${
            isRemoved ? "d-none" : ""
          }`}
        >
          <div className="card-body">
            <Dropdown
              isOpen={this.state.dropdownOpen}
              toggle={this.toggle}
              style={{ float: "right" }}
            >
              <DropdownToggle
                tag="span"
                className="chart-item-menu"
                onClick={this.toggle}
                data-toggle="dropdown"
                aria-expanded={this.state.dropdownOpen}
              >
                <i
                  className="chart-item-menu flaticon-menu-1"
                  style={{ cursor: "pointer" }}
                ></i>
              </DropdownToggle>

              <DropdownMenu
                right
                className="chart-dropdown"
                style={{ padding: "0" }}
              >
                <div
                  className="chart-list-dropdown-options"
                  onClick={() => this.navigateToChart(chart)}
                >
                  <i className="chart-item-menu flaticon-vision" />
                  <span className="chart-list-dropdown-options-text">
                    View Chart
                  </span>
                </div>

                {this.props.isGroups && this.props.chartRemoveBoolean && this.props.chartRemoveBoolean(chart) ? (
                  <If condition={!this.props.hideRemove}>
                    <div
                      className="chart-list-dropdown-options"
                      onClick={() => this.removeGroup(chart)}
                    >
                      <span className="chart-item-menu flaticon-trash" />
                      <span className="chart-list-dropdown-options-text">
                        Remove from Group
                      </span>
                    </div>
                  </If>
                ) : null}
              </DropdownMenu>
            </Dropdown>

            <span className="linkedChartsTitle">{chart.name}</span>

            {/* <span className="taskRemoveChart"  onClick={()=>this.taskRemoveChart(chart._id)}>
                Remove<span className='flaticon-trash'/>
            </span> */}

            <span className="linkedChartsBody">
              <span className="linkedItemCat">{chart.category} </span>{" "}
            </span>
            <span className="linkedChartsBody">
              {" "}
              {attachedBy ? attachedBy : ""} linked on{" "}
              {moment(attachedDate).format("MMM Do, YYYY")}{" "}
            </span>
            <span className="linkedChartsBody">
             {constructGroupLinkedUsersText(chart)}
            </span>
            {/* <span className="linkedChartsBody"> created by {firstName} {lastName}</span> */}

            {this.renderPlot()}
            <Modal isOpen={showManualEntryAnswersModal}>
              <ManualEntryModal
                questionAnswer={kpiData}
                clickedPoint={clickedPoint}
                toggle={() => {
                  this.setState(p => ({
                    showManualEntryAnswersModal: !p.showManualEntryAnswersModal,
                  }));
                }}
              />
            </Modal>
          </div>

          <Modal isOpen={showViewChart} className="viewSingleChartModal">
            <ViewChart
              group={this.props.group}
              showLinkedDashboards={false}
              closeViewChartModal={this.closeViewChartModal}
              chart={chart}
            />
          </Modal>
        </div>
      );
    } else {
      return <div>Retrieving charts...</div>;
    }
  };

  render() {
    return this.renderView();
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
  };
};

// export default LinkedCharts;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(LinkedChartItem, axios)));
